import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CreateBoundaryGroupFromAIModalContainer, type CreateBoundaryGroupFromAIModalContainerProps,
} from './createBoundaryGroupFromAIModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CreateBoundaryGroupFromAI: CreateBoundaryGroupFromAIModalContainerProps;
  }
}
modalRenderer.register('CreateBoundaryGroupFromAI', CreateBoundaryGroupFromAIModalContainer);
